import { render, staticRenderFns } from "./NewFeature.vue?vue&type=template&id=3f4eb23d&scoped=true"
import script from "./NewFeature.vue?vue&type=script&lang=js"
export * from "./NewFeature.vue?vue&type=script&lang=js"
import style0 from "./NewFeature.vue?vue&type=style&index=0&id=3f4eb23d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4eb23d",
  null
  
)

export default component.exports